module.exports = __webpack_public_path__ + "static/media/spinner2.5fe0e55f.gif";